var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.session.sessionId)?_c('div',{staticClass:"voice-runtime",attrs:{"aria-hidden":"true"}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }